import React from 'react';
import {createRoot} from 'react-dom/client';
import AppShare from "../../components/actions/app-share";
import ProductModel from "../../components/product-model";
import ModelContainer from '@core/scripts/components/model-container';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import ProductMessages from "../../components/message-list";
import JshModule from '@core/scripts/helper/jsh-module';
import ProductPage from "../../components/ProductPage.jsx";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";

const {moduleScope, config} = JshModule("product/product-page");

AppShare.addOnShareDataRequestedListener(() => {
    AppShare.publishShareContext();
});

const queryClient = new QueryClient();

const productModel = ProductModel.load();

const productImageDimensions = ModelContainer.get('productImageDimensions');
const breadcrumbs = ModelContainer.get('breadcrumbs');
const sizeGuideTableUrl = ModelContainer.get('sizeGuideTableUrl');
const filterTrackingValue = ModelContainer.get('filterTrackingValue');
const rankingTrackingValue = ModelContainer.get('rankingTrackingValue');
const pageViewId = ModelContainer.get('pageViewId');
const loginLink = ModelContainer.get('loginUrl');
const loggedIn = ModelContainer.get('loggedIn');
const glossaryData = ModelContainer.get('glossary');
const reviewContent = ModelContainer.get('reviewContent');
const experiments = ModelContainer.get('experiments');
const otherCategories = ModelContainer.get('otherCategories');
const pageType = ModelContainer.get('pageType');
const sessionEmail = ModelContainer.get('sessionEmail');
const seoRecommendations = ModelContainer.get('seoRecommendations');
const hideFitFinder = ModelContainer.get('hideFitFinder');
const sizeAdvice = ModelContainer.get('sizeAdvice');
const priceReductionCampaign = ModelContainer.get('priceReductionCampaign');

const {product, texts, staticLinks, pointOfSaleIdOverride, urls} = productModel;

MessageBroker.subscribe(ProductMessages.CHANGED, AppShare.updateShareContext(product, (currentProduct) => {
    const url = window.location.origin + currentProduct?.item?.url;

    const itemUrlParameter = currentProduct?.itemOption
        ? `?itemOptionId=${currentProduct.itemOption.id}&${AppShare.DEFAULT_TRACKING_PARAMETERS}`
        : `?${AppShare.DEFAULT_TRACKING_PARAMETERS}`;

    return {
        productUrl: `${url}${itemUrlParameter}`,
        trackingParameters: "", // This is required to be backwards compatible with Android App versions < 2.3
        productImage: currentProduct?.item?.images[0].preview.sources[0].srcSet.src,
        productTitle: product.name,
        productDescription: product?.shortDescription || product?.description,
        text: texts["ada_social_share_text"]
    };
}));
if (productModel) {
    createRoot(moduleScope).render(
        <QueryClientProvider client={queryClient}>
            <ProductPage
                product={product}
                texts={texts}
                productImageDimensions={productImageDimensions}
                breadcrumbs={breadcrumbs}
                staticLinks={staticLinks}
                sizeGuideTableUrl={sizeGuideTableUrl}
                pointOfSaleIdOverride={pointOfSaleIdOverride}
                filterTrackingValue={filterTrackingValue}
                rankingTrackingValue={rankingTrackingValue}
                pageViewId={pageViewId}
                pageType={pageType}
                loginLink={loginLink}
                loggedIn={loggedIn}
                glossaryData={glossaryData}
                reviewContent={reviewContent}
                experiments={experiments}
                otherCategories={otherCategories}
                config={config}
                sessionEmail={sessionEmail}
                urls={urls}
                seoRecommendations={seoRecommendations}
                hideFitFinder={hideFitFinder}
                sizeAdvice={sizeAdvice}
                priceReductionCampaign={priceReductionCampaign}
            />
        </QueryClientProvider>
    );
}